<ds-promo-badge
  [tone]="type === 'green' ? 'green' : 'sun'"
  [iconSrc]="'assets/icons/' + icon + '.svg'"
  [iconAlt]="icon"
  [label]="title"
/>
